import { render, staticRenderFns } from "./NavbarBrandLayout.vue?vue&type=template&id=8fc83e80&"
import script from "./NavbarBrandLayout.vue?vue&type=script&lang=js&"
export * from "./NavbarBrandLayout.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBrandLayout.vue?vue&type=style&index=0&id=8fc83e80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports